/* global axios */

// Aceleres — API da tela de carteirização do gestor.
// Fala só com o Zoraxy; a carteira vive em contacts.additional_attributes.

const accountId = () => {
  if (window.location.pathname.includes('/app/accounts')) {
    return window.location.pathname.split('/')[3];
  }
  return '';
};

const baseUrl = () => `/api/v1/accounts/${accountId()}/aceleres/portfolio`;

let requestSequence = 0;
const freshParams = (params = {}) => {
  requestSequence += 1;
  return {
    params: { ...params, cache_bust: `${Date.now()}-${requestSequence}` },
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
  };
};

export default {
  index() {
    return axios.get(baseUrl(), freshParams());
  },
  contacts({ ownerId, page = 1, q = '' }) {
    return axios.get(
      `${baseUrl()}/contacts`,
      freshParams({ owner_id: ownerId, page, q })
    );
  },
  // targetOwnerId null/undefined = liberar a carteira
  assign({ contactIds, targetOwnerId = null }) {
    return axios.post(`${baseUrl()}/assign`, {
      contact_ids: contactIds,
      target_owner_id: targetOwnerId,
    });
  },
};
